import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../FontKeys";
import UIAssetKeys from "../UIAssetKeys";

export default class TimeDial extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene);

        ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._time_dial, this).setOrigin(0.5);

        this.textLabel = ABCyaPhaser.Text.addText(0, -32, 38, 0xffffff, FontKeys._odin_roundedregular, "", this).setOrigin(0.5,0);
        this.tickerEnabled = false;
    }

    start() {
        this.startTime = this.scene.time.now;
        this.tickerEnabled = true;
    }

    stop() {
        this.tickerEnabled = false;
    }

    preUpdate() {
        if (!this.tickerEnabled) {
            return;
        }

        this.totalSeconds = Math.floor((this.scene.time.now - this.startTime) / 1000);
        this.textLabel.text = this.totalSeconds;
    }

    getTime() {

        return parseInt(this.textLabel.text);
    }
}